import React, {useState} from 'react';
import {Box, Typography, TextField, Chip} from '@mui/material';
import {useGetDocumentSelectionView} from '../../../hooks/productions/useProductions';
import {GetDocumentSelectionViewRequestParam} from '../../../api/types/production.type';
import ArrButton from '../../../components/common/arr-button/ArrButton';

const DocumentSelectionViewApiTest: React.FC = () => {
  const [securityGroupId, setSecurityGroupId] = useState<number>(1);
  const [productionId, setProductionId] = useState<number>(99);
  const [enabled, setEnabled] = useState<boolean>(false);
  const [copySuccess, setCopySuccess] = useState<boolean>(false);

  const {data, isLoading, error} = useGetDocumentSelectionView(
    {
      SecurityGroupId: securityGroupId,
      productionId: productionId,
    } as GetDocumentSelectionViewRequestParam,
    enabled
  );

  const handleTestApi = () => setEnabled(true);
  const handleReset = () => setEnabled(false);
  const handleCopyJson = async () => {
    if (data) {
      try {
        await navigator.clipboard.writeText(JSON.stringify(data, null, 2));
        setCopySuccess(true);
        setTimeout(() => setCopySuccess(false), 2000);
      } catch (err) {
        console.error('Failed to copy:', err);
      }
    }
  };

  return (
    <Box className="demo-page" padding={3}>
      <Typography
        variant="h5"
        className="typo-text headline3_size"
        gutterBottom
      >
        Document Selection View
      </Typography>
      <Box sx={{display: 'grid', gap: 2, maxWidth: 640, marginTop: 2}}>
        <TextField
          label="Security Group Id"
          type="number"
          value={securityGroupId}
          onChange={(e) => setSecurityGroupId(Number(e.target.value))}
          size="small"
        />
        <TextField
          label="Production Id"
          type="number"
          value={productionId}
          onChange={(e) => setProductionId(Number(e.target.value))}
          size="small"
        />

        <Box sx={{display: 'flex', gap: 1}}>
          <ArrButton
            onClick={handleTestApi}
            disabled={isLoading}
            dataTestId="document-selection-view-api-test-test-api-button">
            Test API
          </ArrButton>
          <ArrButton
            variant="outlined"
            onClick={handleReset}
            dataTestId="document-selection-view-api-test-reset-button">
            Reset
          </ArrButton>
          <ArrButton
            variant="outlined"
            onClick={handleCopyJson}
            disabled={!data}
            dataTestId="document-selection-view-api-test-copy-json-button">
            Copy JSON
          </ArrButton>
          {copySuccess && <Chip color="success" label="Copied!" size="small" />}
        </Box>

        {isLoading && <Typography>Loading...</Typography>}
        {error && (
          <Typography color="error">{(error as Error).message}</Typography>
        )}
        {data && (
          <Box
            component="pre"
            sx={{
              backgroundColor: '#f5f5f5',
              padding: 2,
              borderRadius: 1,
              maxHeight: 480,
              overflow: 'auto',
              fontSize: '12px',
            }}
          >
            {JSON.stringify(data, null, 2)}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default DocumentSelectionViewApiTest;
